<template>
  <div class="custom-tree-container">
    <el-row
      class="content-bottom-padded"
      style="padding-top: 15px; margin-left: 20px"
    >
      <el-col>
        <el-button
          type="primary"
          icon="plus"
          @click="editMerchantCategory"
          size="mini"
          :disabled="isDisable"
          >保存修改</el-button
        >
      </el-col>
    </el-row>

    <div class="block">
      <ul class="custom-tree-node-title">
        <li>Id</li>
        <li>品类名称</li>
        <li>已关联商品类目</li>
        <li>排序</li>
        <li>操作</li>
      </ul>
    </div>
    <div class="tree-background block">
      <el-tree
        v-loading="loading"
        :data="categoryList"
        default-expand-all
        :expand-on-click-node="false"
      >
        <ul class="custom-tree-node" slot-scope="{ node, data }">
          <li>{{ data.category_id }}</li>
          <li>
            <input placeholder="名称" v-model="data.category_name" />
            <el-button
              type="text"
              v-if="data.category_level == 1 || data.category_level == 2"
              @click="
                append(data.children, data.category_level, data.category_id)
              "
              >新增子类目</el-button
            >
          </li>
          <li>
            <el-button
             v-if="data.category_level >1"
              type="text"
              @click="addMid(data)"
            >
              编辑关联
            </el-button>
            <el-tag  v-if="data.category_level >1 && data.items_category_ids"  type="success">({{data.items_category_ids  ? '已添加':''}})</el-tag>
          </li>
          <li>
            <span style="padding-right: 100px"
              ><input
                style="width: 50px"
                placeholder="排序"
                v-model="data.sort"
            /></span>
          </li>
          <li>
            <el-button type="text"  @click="delMerchantCategory(node, data)">
                <i class="iconfont icon-trash-alt"></i>
            </el-button>
          </li>
        </ul>
      </el-tree>
      <div class="add-category">
        <span @click="append(categoryList)"
          ><i class="el-icon-plus"></i>新增</span
        >
      </div>
       <el-dialog :title="title" :visible.sync="dialogFormVisible">
        <el-form ref="form" :model="form" >
          <el-form-item label="选择商品分类" >
              <el-cascader
               v-model="form.items_category_ids"
            :options="itemCategoryList"
            :props="props"
            >
            </el-cascader>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible = false">取 消</el-button>
          <el-button type="primary" @click="onSubmit()">确 定</el-button>
        </div>
      </el-dialog>
    </div>

  </div>
</template>
<script>
import {
  getMerchantCategory,
  delMerchantCategory,
  addMerchantCategory,
  editMerchantCategory,
  saveMerchantCategoryMid
} from "../../../api/merchant";
import { getCategory } from "@/api/goods";
import { forEach } from 'jszip';
export default {
  components: {},
  data() {
    return {
      props: { multiple: true, checkStrictly: true },
      title:'',
      form:{category_id:'',items_category_ids:''},
      isDisable: false,
      loading: false,
      spaceInput: false,
      categoryList: [],
      dialogFormVisible: false,
      itemCategoryList:[],
    };
  },
  methods: {
    getCategoryName(data){
        count=0;
        for(var i=0;i<this.itemCategoryList.length;i++){
          for(var j=0;j<data.length;j++){
              if(data[j] == parseInt(this.itemCategoryList[i].category_id) ){
                  arr+=this.itemCategoryList[i].category_name+','
                  count++;
              }
          }
        }
        return count;
    },
    onSubmit(){
      saveMerchantCategoryMid(this.form).then((res)=>{
           this.$message({
            type: "success",
            message: "保存成功",
          });
         this.dialogFormVisible=false;
         this.getlist();
      })
    },
    addMid(data) {
      this.dialogFormVisible=true;
      this.form.items_category_ids=data.items_category_ids;
      this.form.category_id=data.category_id;
      this.title=data.category_name

    },
    getItemCategory(){
      getCategory({ is_main_category:true}).then((response)=>{
        this.itemCategoryList=response.data.data;
      })
    },
    getlist() {
      this.loading = true;
      getMerchantCategory({ ishtml: 1, is_save: 1 }).then((response) => {
        this.categoryList = response.data.data;
        this.loading = false;
        this.spaceInput = false;
        this.getItemCategory();
      });
    },
    editMerchantCategory() {
      for (var i = 0; i < this.categoryList.length; i++) {
        for (var a = i; a < this.categoryList.length - 1; a++) {
          if (
            this.categoryList[i].category_name ==
            this.categoryList[a + 1].category_name
          ) {
            this.$message({
              type: "error",
              message: "同级类目名称不能相同.",
            });

            return false;
          }
        }
        if (!this.catNameCheck(this.categoryList[i].category_name)) {
          return false;
        }

        for (var j = 0; j < this.categoryList[i].children.length; j++) {
          for (
            var b = 0;
            b < this.categoryList[i].children.length - 1 - j;
            b++
          ) {
            if (
              this.categoryList[i].children[b].category_name ==
              this.categoryList[i].children[b + 1].category_name
            ) {
              this.$message({
                type: "error",
                message: "同级类目名称不能相同!",
              });
              return false;
            }
          }
          if (
            !this.catNameCheck(this.categoryList[i].children[j].category_name)
          ) {
            return false;
          }
        }
      }
      this.isDisable = true;
      setTimeout(() => {
        this.isDisable = false;
      }, 1000);
      let form = JSON.stringify(this.categoryList);
      addMerchantCategory({ form: form }).then((response) => {
        this.$message({
          type: "success",
          message: "保存成功",
        });
        this.getlist();
      });
    },
    delMerchantCategory(node, data) {
      this.$confirm("此操作将删除该, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          if (typeof data.category_id != "undefined") {
            delMerchantCategory(data.category_id).then((response) => {
              this.$message({
                type: "success",
                message: "删除成功",
              });
              this.getlist();
            });
          } else {
            const parent = node.parent;
            const children = parent.data.children || parent.data;
            const index = children.findIndex((d) => d.id === data.id);
            children.splice(index, 1);
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    noUse() {
      this.$message({
        type: "info",
        message: "该功能已被禁用",
      });
      return false;
    },
    append(data, category_level = 0, pid = 0) {
      var new_category_level = category_level + 1;
      const newChild = {
        category_name: "",
        parent_id: pid,
        sort: 0,
        category_level: new_category_level,
        children: [],
      };
      data.push(newChild);
    },
    catNameCheck(catName) {
      let catNameLength = 0;
      if (catName) {
        for (var i = 0; i < catName.length; i++) {
          if (catName.charCodeAt(i) > 255) {
            catNameLength += 2;
          } else {
            catNameLength++;
          }
        }
        console.log(catName);
        if (catNameLength > 50) {
          this.$message({
            type: "error",
            message: "分类长度最多25个汉字或50个字符",
          });
          return false;
        }
        return true;
      } else {
        this.$message({
          type: "error",
          message: "分类不能为空",
        });
        return false;
      }
    },
  },
  mounted() {
    this.getlist();

  },
};
</script>

<style scoped lang="scss">
.sku-value {
  margin-right: 10px;
}

.custom-tree-container {
  background-color: #fff;
}

.tree-background {
  padding-bottom: 45px;
  margin: 0px 20px;
}

.custom-tree-node,
.custom-tree-node-title {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
  li {
    display: inline-block;
    text-align: center;
    width: 25%;
  }
  li:first-child {
    text-align: left;
  }
  li.category-icon {
    display: flex;
    align-items: middle;
    justify-content: center;
    span {
      height: 30px;
    }
    img {
      width: auto;
      height: 30px;
    }
  }
}

.custom-tree-node-title {
  font-weight: bold;
  color: #909399;
  margin: 0px 20px;
  li {
    padding: 12px 0;
  }
}

.add-category {
  margin-left: 25px;
  margin-top: 30px;
  span {
    cursor: pointer;
  }
}

.remove-category {
  margin-left: 10px;
}

.add-child-category {
  margin-left: 10px;
}
</style>
<style lang="scss">
.custom-tree-container {
  .el-tree-node__content {
    height: 45px;
    padding: 0px;
    line-height: 45px;
  }
  .el-tree > .el-tree-node {
    position: relative;
    &::after {
      position: absolute;
      height: 1px;
      left: 0;
      right: 0;
      bottom: 0;
      content: "";
      background-color: #e6e6e6;
    }
  }
  .el-tree > .el-tree-node:first-child {
    &::before {
      position: absolute;
      height: 1px;
      left: 0;
      right: 0;
      top: 0;
      content: "";
      background-color: #e6e6e6;
    }
  }
}

.custom-tree-node {
  input {
    border: 1px solid #ddd;
    line-height: 25px;
    padding-left: 5px;
    width: 150px;
  }
}
</style>



// WEBPACK FOOTER //
// list.vue?87d7667c